import React, { FC } from 'react';

const IconCapraboClubMenuMovile: FC = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
    >
      <path
        fill="#2FB3E8"
        d="M78.029,98.54H21.971c-11.281,0-20.51-9.23-20.51-20.51V21.971c0-11.281,9.23-20.51,20.51-20.51
                		h56.059c11.281,0,20.51,9.23,20.51,20.51v56.059C98.54,89.31,89.31,98.54,78.029,98.54z"
      />
      <g id="XMLID_338_" fill="#FFFFFF">
        <path
          id="XMLID_370_"
          d="M20.357,47.423v5.307c0,0.723-0.609,1.311-1.359,1.311h-3.5
                			c-1.465,0-2.682-1.164-2.682-2.576c0-1.412,1.188-2.557,2.652-2.557h1.437l1.034-0.001c0.363,0,0.655-0.267,0.655-0.617
                			c0-0.349-0.302-0.629-0.664-0.629l-8.22,0.015c-1.331,0-2.411,1.041-2.411,2.324c0,1.283,1.079,2.324,2.411,2.324h2.799v1.71
                			l-2.8,0.015c-2.318,0-4.198-1.812-4.198-4.048c0.001-2.236,1.88-4.048,4.199-4.048h9.145c0.834,0,1.509,0.652,1.509,1.456
                			L20.357,47.423z M15.651,50.63c-0.591,0-1.07,0.271-1.07,0.84c0,0.567,0.479,0.858,1.07,0.858h2.663
                			c0.138,0,0.251-0.108,0.251-0.242v-1.453h-1.66L15.651,50.63z"
        />
        <path
          id="XMLID_369_"
          d="M46.893,54.049c2.318,0,4.198-1.812,4.198-4.048c0-2.234-1.88-4.047-4.198-4.047
                			l-1.762,0.015v1.709h1.762c1.331,0,2.409,1.04,2.409,2.323c0,1.284-1.078,2.324-2.409,2.324l-2.17,0.012
                			c-0.154,0-0.279-0.119-0.279-0.268v-8.636h-1.773v9.159c0,0.803,0.676,1.455,1.51,1.455L46.893,54.049z"
        />
        <path
          id="XMLID_368_"
          d="M25.361,45.95c2.319,0,4.198,1.811,4.198,4.047c0,2.236-1.879,4.048-4.198,4.048
                			l-1.762-0.015v-1.71h1.762c1.331,0,2.41-1.041,2.41-2.324c0-1.283-1.079-2.323-2.41-2.323l-2.169-0.013
                			c-0.154,0-0.279,0.119-0.279,0.268v8.639h-1.773l0-9.161c0-0.803,0.676-1.456,1.51-1.456L25.361,45.95z"
        />
        <path
          id="XMLID_365_"
          d="M35.02,47.661h-2.914c-0.154,0-0.279,0.12-0.279,0.268v6.117h-1.773v-6.639
                			c0-0.803,0.676-1.456,1.51-1.456h9.013c0.835,0,1.51,0.652,1.51,1.456l-0.007,0.016v5.307c0,0.723-0.609,1.311-1.359,1.311h-3.5
                			c-1.465,0-2.682-1.164-2.682-2.576c0-1.412,1.187-2.557,2.652-2.557h1.437l1.033-0.001c0.363,0,0.655-0.267,0.655-0.617
                			c0-0.349-0.302-0.629-0.665-0.629H35.02z M37.373,50.63c-0.591,0-1.07,0.271-1.07,0.84c0,0.567,0.479,0.858,1.07,0.858h2.663
                			c0.138,0,0.251-0.108,0.251-0.242v-1.453h-1.66L37.373,50.63z"
        />
        <path
          id="XMLID_362_"
          d="M55.472,52.325c-1.331,0-2.41-1.04-2.41-2.324c0-1.283,1.078-2.322,2.41-2.322
                			c1.331,0,2.41,1.04,2.41,2.322C57.882,51.285,56.802,52.325,55.472,52.325 M55.472,45.954c-2.319,0-4.199,1.812-4.199,4.047
                			c0,2.236,1.88,4.048,4.199,4.048c2.319,0,4.198-1.812,4.198-4.048C59.67,47.766,57.79,45.954,55.472,45.954"
        />
        <path
          id="XMLID_361_"
          d="M72.031,49.982c0,2.692-2.184,4.876-4.876,4.876c-2.694,0-4.877-2.185-4.877-4.876
                			c0-2.695,2.183-4.878,4.877-4.878C69.847,45.104,72.031,47.287,72.031,49.982"
        />
        <path
          id="XMLID_360_"
          d="M83.244,49.982c0,2.692-2.184,4.876-4.876,4.876c-2.694,0-4.877-2.185-4.877-4.876
                			c0-2.695,2.183-4.878,4.877-4.878C81.06,45.104,83.244,47.287,83.244,49.982"
        />
        <path
          id="XMLID_359_"
          d="M94.489,49.982c0,2.692-2.184,4.876-4.877,4.876c-2.693,0-4.877-2.185-4.877-4.876
                			c0-2.695,2.184-4.878,4.877-4.878C92.305,45.104,94.489,47.287,94.489,49.982"
        />
      </g>
    </svg>
  );
};

export default IconCapraboClubMenuMovile;
